import(/* webpackMode: "eager" */ "/vercel/path0/app/en/layout.tsx");
